import { render, staticRenderFns } from "./etcManage.vue?vue&type=template&id=08849eac&scoped=true&"
import script from "./etcManage.vue?vue&type=script&lang=js&"
export * from "./etcManage.vue?vue&type=script&lang=js&"
import style0 from "./etcManage.vue?vue&type=style&index=0&id=08849eac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08849eac",
  null
  
)

export default component.exports